import { Fees, FormItem, Space } from '../../../../../../components/core-v2'
import { Fee } from '../../../../types'

type Props = {
  portfolioFees: Fee[]
}

export const PortfolioCharges = ({ portfolioFees }: Props) => (
  <Space mx={5} my={6}>
    <FormItem>
      <Fees fees={portfolioFees} title="Portfolio charges" />
    </FormItem>
  </Space>
)
